import {
  FormInput,
  validatePassword,
  validatePasswordsMatch,
  validateRequired,
} from 'components/shared/Forms/ReduxForm'
import Navigation from 'components/shared/Navigation/Navigation'
import logo from 'images/logo.svg'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, getFormValues, initialize, reduxForm } from 'redux-form'
import { resetForm, submitNewPassword } from 'redux/user'
import {
  Button,
  Card,
  Container,
  Form,
  Grid,
  Icon,
  Image,
  List,
  Segment,
} from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { serverErrors } = state.user
  const formValues = getFormValues(ownProps.form)(state)
  return { serverErrors, formValues }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      resetForm,
      submitNewPassword,
      initialize,
    },
    dispatch
  )
}

class ChangePassword extends React.Component {
  componentWillMount() {
    const { resetForm, initialize } = this.props
    resetForm()
    initialize('changePassword', {
      reset_password_token: this.props.location.query.reset_password_token,
    })
  }

  render() {
    const { submitNewPassword, formValues, invalid } = this.props
    const submitButtonProps = {
      disabled: invalid,
      content: I18n.t('login.reset_password.submit'),
      onClick: (event) => {
        event.preventDefault()
        submitNewPassword(formValues)
      },
    }

    return (
      <div>
        <Segment basic className="loginArea">
          <Container>
            <Grid centered columns={1} stackable>
              <Grid.Row>
                <Grid.Column
                  width={12}
                  className="flex-center"
                  style={{ minHeight: '100px' }}>
                  <Image src={logo} size="small" />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column mobile={12} tablet={6} computer={5} widescreen={4}>
                  <Card fluid>
                    <Card.Content>
                      <Card.Header as="h1">
                        {I18n.t('login.reset_password.title')}
                      </Card.Header>
                      <Card.Description>
                        {I18n.t('login.reset_password.header')}
                        <Form error={invalid}>
                          <Field
                            component={FormInput}
                            type="hidden"
                            name="reset_password_token"
                          />
                          <Field
                            component={FormInput}
                            validate={[validateRequired, validatePassword]}
                            autoFocus
                            type="password"
                            size="large"
                            placeholder={I18n.t('global.password')}
                            name="password"
                          />
                          <Field
                            component={FormInput}
                            validate={[validateRequired, validatePassword]}
                            type="password"
                            size="large"
                            placeholder={I18n.t(
                              'login.reset_password.password_confirmation'
                            )}
                            name="password_confirmation"
                          />

                          <Button {...submitButtonProps} fluid primary />
                        </Form>
                      </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                      <List>
                        <List.Item>
                          <Icon name="angle right" />
                          <List.Content>
                            <Navigation
                              node="user/login"
                              render="link"
                              as="link-item"
                              children={I18n.t('global.cancel')}
                            />
                          </List.Content>
                        </List.Item>
                      </List>
                    </Card.Content>
                  </Card>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </div>
    )
  }
}

ChangePassword = connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
ChangePassword = reduxForm({
  form: 'changePassword',
  validate: validatePasswordsMatch,
})(ChangePassword)
export default ChangePassword



// WEBPACK FOOTER //
// ./src/components/shared/Login/ChangePassword.jsx